import { DELETE_ACTIVE_SEAT_BY_USER, SET_ACTIVE_SEAT_LIST_BY_USER, SET_SEAT_ADDRESS, SET_SEAT_BY_TOKEN } from './actions';

export const listActiveSeatByUserReducer = (state = [], action) => {
     switch (action.type) {
          case SET_ACTIVE_SEAT_LIST_BY_USER: {
               return action.payload;
          }
          case DELETE_ACTIVE_SEAT_BY_USER: {
               const newActiveSeats = [...state];
               return newActiveSeats.filter((seat) => seat.id !== action.payload);
          }
          default:
               return state;
     }
};

export const seatByTokenReducer = (state = null, action) => {
     switch (action.type) {
          case SET_SEAT_BY_TOKEN: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const seatAddressReducer = (state = {}, action) => {
     switch (action.type) {
          case SET_SEAT_ADDRESS: {
               return action.payload;
          }
          default:
               return state;
     }
};
